module.exports = __webpack_public_path__ + "63f3e241.svg";